import { Model } from "./model";

export class Sepa extends Model {
	private iban: string = "";
	private receiver: string = "";
	private bic: string = "";
	private bank: string = "";
	private bank_address: string = "";
	private receiver_address: string = "";
	private sdd: boolean = true; // SEPA support -> default "true" to show error only on API response "false"
	private sort_code: string = "";
	private account_number: string = "";
	private unique_payment_number: string = "";
	private preferred_account_information: "international" | "local" = "international";

	public getIban(): string {
		return this.iban;
	}

	public getReceiver(): string {
		return this.receiver;
	}

	public getBic(): string {
		return this.bic;
	}

	public getBank(): string {
		return this.bank;
	}

	public getBankAddress(): string {
		return this.bank_address;
	}

	public getReceiverAddress(): string {
		return this.receiver_address;
	}

	public isSepaEnabled(): boolean {
		return this.sdd;
	}

	public getSortCode(): string {
		return this.sort_code;
	}

	public getAccountNumber(): string {
		return this.account_number;
	}

	public isGBPBankTransfer(): boolean {
		return this.preferred_account_information === "local";
	}

	public getUniquePaymentNumber(): string {
		return this.unique_payment_number;
	}
}
